// src/components/fuel/TodayStats.js
import React from 'react';
import { Droplets, DollarSign, TrendingUp } from 'lucide-react';
import { fmt, fmtUSD } from './formatters';

const TodayStats = ({ stats }) => {
  if (!stats) return null;
  
  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 p-4">
      <h3 className="text-white font-semibold flex items-center gap-2 mb-3 text-sm">
        <TrendingUp size={16} className="text-blue-400" />
        Today's Activity
      </h3>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Droplets size={16} className="text-blue-400" />
            <span className="text-gray-400 text-xs">Gallons</span>
          </div>
          <span className="text-white font-bold text-base">{fmt(stats.total_gallons, 1)}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <DollarSign size={16} className="text-green-400" />
            <span className="text-gray-400 text-xs">Revenue</span>
          </div>
          <span className="text-white font-bold text-base">{fmtUSD(stats.total_revenue)}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingUp size={16} className="text-orange-400" />
            <span className="text-gray-400 text-xs">Transactions</span>
          </div>
          <span className="text-white font-bold text-base">{fmt(stats.transaction_count)}</span>
        </div>
      </div>
    </div>
  );
};

export default TodayStats;